var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discussion-block-section"},[_c('div',{staticClass:"title-text font-weight-bold color_grey_dark"},[_vm._v("PARTICIPANT")]),_c('DiscussionCard'),_c('DiscussionCard'),_c('DiscussionCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }